import React, { Children } from 'react';
import { motion } from 'framer-motion';
const stackItems = [{
  icon: '📖',
  title: 'Ebook Principal: "Emprender con Unción"',
  value: '$197',
  description: 'El mapa completo de 40 páginas para lanzar tu negocio legalmente en EE.UU. bajo principios bíblicos.'
}, {
  icon: '🎁',
  title: 'BONO #1: Plan de Negocio de 1 Página',
  value: '$67',
  description: 'El formato simplificado para que dejes de planear y empieces a facturar en menos de 60 minutos.'
}, {
  icon: '🎁',
  title: 'BONO #2: IA para el Reino',
  value: '$47',
  description: 'Aprende a usar la Inteligencia Artificial para ganar 10 horas libres a la semana y dedicarlas a lo que realmente importa: Dios y tu familia.'
}, {
  icon: '🎁',
  title: 'BONO #3: Venta con Propósito',
  value: '$97',
  description: 'El guion exacto para cerrar ventas con honestidad y autoridad, eliminando el miedo a cobrar.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ValueStack() {
  return <section className="bg-charcoal text-cream py-20 md:py-28 px-4 border-t border-gold/10" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-serif text-gold mb-4" data-id="element-124">
            Si decides tomar acción hoy, esto es lo que recibirás de inmediato:
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-125">
          {stackItems.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-cream/5 border border-gold/20 p-6 md:p-8 rounded-sm flex flex-col md:flex-row gap-6 items-start hover:bg-cream/10 transition-colors" data-id="element-126">
              <div className="text-4xl md:text-5xl flex-shrink-0" data-id="element-127">
                {item.icon}
              </div>
              <div className="flex-1" data-id="element-128">
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mb-3" data-id="element-129">
                  <h3 className="text-xl md:text-2xl font-serif text-gold" data-id="element-130">
                    {item.title}
                  </h3>
                  <span className="text-cream/50 line-through text-sm md:text-base whitespace-nowrap" data-id="element-131">
                    (Valor {item.value})
                  </span>
                </div>
                <p className="text-cream/80 leading-relaxed" data-id="element-132">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.5
      }} className="mt-16 text-center p-8 border-2 border-gold/30 bg-gold/5 rounded-sm" data-id="element-133">
          <h3 className="text-2xl md:text-3xl font-bold text-cream" data-id="element-134">
            VALOR TOTAL DE ESTE PAQUETE:{' '}
            <span className="line-through text-gold/60 ml-2" data-id="element-135">$408</span>
          </h3>
        </motion.div>
      </div>
    </section>;
}